import { BorderOutlined } from '@ant-design/icons';
import { FormValidatorBuilder } from '../../../../../validator/form-builder/FormValidatorBuilder.ts';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { ColumnWidgetComponent } from './ColumnWidgetComponent.tsx';
import {
  ColumnWidgetConfigComponent,
  ColumnWidgetConfigSchema,
} from './ColumnWidgetConfigComponent.tsx';
import { type IColumnWidget } from './IColumnWidget.ts';
import { renderColumnHtml } from './renderColumnHtml.ts';

/**
 * Tipo del componente Comtainer Colonna.
 */
export const ColumnWidgetType: IWidgetType<IColumnWidget> = {
  type: WidgetType.Column,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Container,
  name: 'Colonna',
  icon: <BorderOutlined />,
  hasValue: false,
  formComponent: ColumnWidgetComponent,
  createFormSchema: ({ widget, parentScope, section, page }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);
    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  configComponent: ColumnWidgetConfigComponent,
  configValidator: ColumnWidgetConfigSchema,
  previewComponent: ColumnWidgetComponent,
  translationSchema: tran.widget({}),
  rules: [],
  renderHtml: renderColumnHtml,
};
